import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-version-component',
  templateUrl: './version-component.component.html',
  styleUrls: ['./version-component.component.css']
})
export class VersionComponentComponent {
  version!: string;
  projectName!: string;
  constructor() {
    this.version = environment.version
    this.projectName = environment.projectName
  }
}
